'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildOrderedMessageMap = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require('immutable');

var _buildMessageKey = require('../pubnub-message/operators/buildMessageKey');

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _buildMessageFromType = require('./operators/buildMessageFromType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Construct an OrderedMap<string, PubNubMessageModel> from Array<Message Objects>
 *
 * @param {Iterable} messages Message objects returned by the history API
 */
var buildOrderedMessageMap = exports.buildOrderedMessageMap = function buildOrderedMessageMap() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  (0, _invariant2.default)(_immutable.Iterable.isIterable(messages) || Array.isArray(messages), 'Expected messages to be iterable not a `%s`', typeof messages === 'undefined' ? 'undefined' : _typeof(messages));
  return messages.reduce(function (acc, messageObject) {
    var message = (0, _buildMessageFromType.buildMessageFromType)(messageObject);
    var key = (0, _buildMessageKey.buildMessageKey)(message);

    return acc.set(key, message);
  }, (0, _immutable.OrderedMap)());
};